const fields = new Map()

import FlatfinderApi from '@/api/Flatfinder'
import { Nest } from '@/components/Flatfinder/utils'
import { uploadOptions } from '@/components/Flatfinder/constants'

fields.set('name', ctx => ({
  key: 'name',
  defaultPlacement: 'basis',
  component: 'InputComponent',
  props: {
    label: ctx.labels.name,
    required: true,
  },
}))

fields.set('description', ctx => ({
  key: 'description',
  defaultPlacement: 'basis',
  component: 'InputComponent',
  props: {
    label: ctx.$t('description'),
    placeholder: ctx.$t('exampleFlatfinderDescription'),
  },
}))

fields.set('isEntry', ctx => ({
  key: 'isEntry',
  defaultPlacement: 'basis',
  component: 'CheckboxComponent',
  props: {
    label: ctx.$t('flatfinderIsEntry'),
  },
}))

fields.set('parent', ctx => {
  const getFlatfinders = filter => {
    return FlatfinderApi.get(
      {
        filter: {
          ...filter,
          project: ctx.project,
          exclude: ctx.data.id ? [ctx.data.id] : undefined,
        },
      },
      { draft: ctx.draft },
    ).then(Nest)
  }

  return {
    key: '',
    defaultPlacement: 'basis',
    component: 'InputComponent',
    props: {
      label: ctx.$t('superiorUnitSelector'),
      sublabel: ctx.$t('chooseSubordinateUnitSelector'),
    },
    slots: {
      default: [
        {
          key: 'parent',
          component: 'FlatfinderSelect',
          props: {
            items: getFlatfinders,
            search: true,
            class: 'elder-input__element',
          },
        },
      ],
    },
  }
})

fields.set('image', ctx => ({
  key: 'frames.0.image',
  defaultPlacement: 'basis',
  component: 'MediaComponent',
  disabled: (ctx.data.frames || []).length > 1 ? ctx.$t('flatfinderImageLockedByFrames') : false,
  props: {
    label: ctx.labels['frames.0.image'],
    required: true,
    uploadOptions,
    size: 'contain',
    enableDescription: false,
    enableAlt: false,
  },

  slots: {
    ['drop-message']: [
      {
        component: 'MediaOnDrop',
        slots: {
          default: [
            {
              component: 'MediaRecommendation',
              props: {
                value: 'flatfinder',
              },
            },
          ],
        },
      },
    ],
  },
}))

export default fields
